export default __webpack_public_path__ + "static/media/Tunic of the Lector.71847ec4.jpg";